// @flow
import { getCreator, postCreator } from '../../http';
import environment from '../../environment';
import { of } from 'rxjs';

export const endpoints = Object.freeze({
  GET_PUNCH_CARD_POINTS: `${environment.apiUrl}/punch-card/get-stamps-count`,
  POST_PUNCH_CARD_CLAIM: `${environment.apiUrl}/punch-card/claim`,
});

export const getPunchCardPoints = getCreator(fetch, endpoints.GET_PUNCH_CARD_POINTS);
export const postPunchCardClaim = postCreator(fetch, endpoints.POST_PUNCH_CARD_CLAIM);



// WEBPACK FOOTER //
// ./src/modules/punch-card/api.js